import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import {
  catchError,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import {
  CATEGORY_FIND,
  CATEGORY_FIND_SUCCESS,
  CATEGORY_FAILED,
  CATEGORY_UPDATE_LOADING,
  CATEGORY_UPDATE_ID,
} from '@store/actions';
import { CategoryService } from '@core/services';
import { Store } from '@ngrx/store';
import { selectLocalChannelId } from '../selectors';
import { Category } from '@core/models';

@Injectable()
export class CategoryEffects {
  localChannelId$: Observable<string | null>;

  constructor(
    private actions$: Actions,
    private categoryService: CategoryService,
    private store: Store
  ) {
    this.localChannelId$ = this.store.select(selectLocalChannelId)
  }

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CATEGORY_FIND),
      withLatestFrom(
        this.store.select(selectLocalChannelId)
      ),
      map(([_,localChannelId])=>{
        return { localChannelId: localChannelId as string };
      }),
      mergeMap(({ localChannelId }) =>{
        this.store.dispatch(CATEGORY_UPDATE_LOADING({loading:true}))
        return this.categoryService.getCategoryByLocalChannelId(localChannelId).pipe(
          mergeMap(({ data }) => {
            return [
              CATEGORY_FIND_SUCCESS({ categoryList: data }),
              CATEGORY_UPDATE_ID({categoryId: data[0].idCategoria}),
              CATEGORY_UPDATE_LOADING({loading: false}),
            ];
          }),
          catchError((error) =>
            of(
              CATEGORY_FAILED({
                error: error.error?.message || 'Error loading categories',
              })
            )
          )
        )
      }
      )
    )
  );
}
